import { Workbook } from "exceljs";
import {
  excelHelper,
  fileHelper,
  formatHelper,
} from "../../../../common/helpers";

/**
 *
 * @param {any[]} categoryBalance
 * @returns {Workbook}
 */
export const exportExcel = async (
  categoryDetailedBalance,
  selectedStore,
  startDate,
  endDate
) => {
  let totalIncome = 0;
  const excelData = [];

  for (let item = 0; item < categoryDetailedBalance.length; item++) {
    const balance = categoryDetailedBalance[item];

    excelData.push({
      order: item + 1,
      name: balance.Item.Category.name,
      customer: `${balance.Customer.name} ${balance.Customer.lastname}`,
      items: `${balance.Item.quantity} ${balance.Item.name}`,
      paymentType: balance.Sell_payment_type.name,
      totalNet: balance.Item.total_net,
    });

    totalIncome += balance.Item.total_net;
  }

  excelData.push({
    order: "",
    name: "TOTAL",
    customer: "",
    items: "",
    paymentType: "",
    totalNet: totalIncome,
  });

  const json = excelHelper.jsonToJson(
    [excelData],
    [
      {
        name: "BALANCE POR CATEGORIA DETALLADO",
        props: [
          {
            inValue: "order",
            outValue: "",
          },
          {
            inValue: "name",
            outValue: "CATEGORIA",
          },
          {
            inValue: "customer",
            outValue: "CLIENTE",
          },
          {
            inValue: "items",
            outValue: "CONCEPTO",
          },
          {
            inValue: "paymentType",
            outValue: "FORMA DE PAGO",
          },
          {
            inValue: "totalNet",
            outValue: "TOTAL RECAUDADO",
          },
        ],
      },
    ]
  );
  const workbook = excelHelper.jsonToExcelJs(json);
  const fileName = getFileName(selectedStore, startDate, endDate);
  const blob = await excelHelper.workbookToBlob(workbook);
  fileHelper.downloadBlob(blob, fileName);
};

const getFileName = (selectedStore, startDate, endDate) => {
  const storeName = selectedStore.label;
  return selectedStore.value == 0
    ? formatHelper.toDateYYMMDD(new Date().toUTCString()) +
        "_reporte-detallado-general-por-categoria_" +
        formatHelper.toDateYYMMDD(startDate._d) +
        "_" +
        formatHelper.toDateYYMMDD(endDate._d) +
        ".xlsx"
    : formatHelper.toDateYYMMDD(new Date().toUTCString()) +
        "_reporte-detallado-por-categoria_" +
        storeName.toLowerCase() +
        "_" +
        formatHelper.toDateYYMMDD(startDate._d) +
        "_" +
        formatHelper.toDateYYMMDD(endDate._d) +
        ".xlsx";
};

/**
 *
 * @param {any[]} categoryBalance
 * @returns {Workbook}
 */
export const exportExcelGeneral = async (
  categoryBalance,
  selectedStore,
  startDate,
  endDate
) => {
  let totalQuantity = 0;
  let totalIncome = 0;

  const excelData = [];

  for (let item = 0; item < categoryBalance.length; item++) {
    const balance = categoryBalance[item];

    excelData.push({
      order: item + 1,
      name: balance.name,
      quantity: balance.quantity,
      total: balance.total,
    });

    totalQuantity += balance.quantity;
    totalIncome += balance.total;
  }

  excelData.push({
    order: "",
    name: "TOTAL",
    quantity: totalQuantity,
    total: totalIncome,
  });

  const json = excelHelper.jsonToJson(
    [excelData],
    [
      {
        name: "BALANCE POR CATEGORIA",
        props: [
          {
            inValue: "order",
            outValue: "",
          },
          {
            inValue: "name",
            outValue: "CATEGORIA",
          },
          {
            inValue: "quantity",
            outValue: "CANTIDAD",
          },
          {
            inValue: "total",
            outValue: "TOTAL RECAUDADO",
          },
        ],
      },
    ]
  );
  const workbook = excelHelper.jsonToExcelJs(json);
  const fileName = getFileNameGeneral(selectedStore, startDate, endDate);
  const blob = await excelHelper.workbookToBlob(workbook);
  fileHelper.downloadBlob(blob, fileName);
};

const getFileNameGeneral = (selectedStore, startDate, endDate) => {
  const storeName = selectedStore.label;
  return selectedStore.value == 0
    ? formatHelper.toDateYYMMDD(new Date().toUTCString()) +
        "_reporte-general-por-categoria_" +
        formatHelper.toDateYYMMDD(startDate._d) +
        "_" +
        formatHelper.toDateYYMMDD(endDate._d) +
        ".xlsx"
    : formatHelper.toDateYYMMDD(new Date().toUTCString()) +
        "_reporte-por-categoria_" +
        storeName.toLowerCase() +
        "_" +
        formatHelper.toDateYYMMDD(startDate._d) +
        "_" +
        formatHelper.toDateYYMMDD(endDate._d) +
        ".xlsx";
};



// WEBPACK FOOTER //
// ./src/scenes/Report/Balance/CategoryBalance/excel.js